import { Receipt } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The «Boletas» destination (§4.12 of the screen inventory): the boleta
 * envelopes (view 10).
 *
 * It used to be «Boletas y folios» and also held the RCOF (view 11). The design
 * critique (R8(i), C-2 resolved: go) moved the RCOF next to the folio stock in
 * `folios.nav.ts`, because an operator thinks about folios as one topic. What is
 * left here is the envelopes, kept as a child so the group reads «Boletas» →
 * «Sobres» exactly as the resolution words it.
 *
 * `GET /api/boletas` closed D9 (A-03 of the frontend roadmap), so nothing here
 * depends on the backend any more.
 */
export const boletasNav: readonly NavItem[] = [
  {
    label: 'Boletas',
    to: '/boletas',
    icon: Receipt,
    group: 'operation',
    minimumPhase: 'in-certification',
    children: [{ label: 'Sobres', to: '/boletas' }],
  },
];
